module.exports = __webpack_public_path__ + "img/lava.b37ec438.jpg";